import { render, staticRenderFns } from "./FormInput2.vue?vue&type=template&id=27337fa5&scoped=true&"
import script from "./FormInput2.vue?vue&type=script&lang=js&"
export * from "./FormInput2.vue?vue&type=script&lang=js&"
import style0 from "./FormInput2.vue?vue&type=style&index=0&id=27337fa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27337fa5",
  null
  
)

export default component.exports